/**=========================================================
 * Module: tmupload.js
 * Privacy Controller
 =========================================================*/

App.controller('TmuploadController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', '$filter', '$http', 'DataService', 'ngDialog',
    function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, $filter, $http, D, ngDialog) {
      "use strict";

      $scope.client = $state.params.name;

      function toggleFields(view){
        //$scope.tmuploadform.fields[3].available = view;
        //$scope.tmuploadform.fields[4].available = view;
        if(!view){
          //$scope.tmuploadform.fields[0].name = setFieldName();
          /*$scope.tmuploadform.model.source = '';
          $scope.tmuploadform.model.target = '';
          $scope.tmuploadform.model.context = '';*/
        }
      }

      function selectedLang(){
        if($scope.tmuploadform.model.source && $scope.tmuploadform.model.target){
          toggleFields(true);
        }
        $scope.uploadSuccess = false;
        $scope.uploadError = false;
      }

      $scope.uploadSuccess = false;
      $scope.uploadError = false;

      var updatedFiles = [];
      $scope.uploadedFiles = function(files){
        var counter = 0; 
        for(var i=0; i<files.length; i++){
          if(updatedFiles.indexOf(files[i].id)>=0) break;
          updatedFiles.push(files[i].id);
          files[i].action = 'SetFileInfo';
          files[i].info = { tm: 
            { 
              /*source: $scope.tmuploadform.model.source, 
              target: $scope.tmuploadform.model.target, 
              context: $scope.tmuploadform.model.context,*/
              reference: $scope.referenceId
            }
          }
          D.save('file', files[i]).then(function(res){
            counter++;
            if(counter==files.length){
              $scope.uploadSuccess = true;
              toggleFields(false);
              $scope.loadFiles();
            }
          }).catch(function(err){
            $scope.uploadError = true;
            toggleFields(false);
            $scope.loadFiles();
          })
        }
        //$scope.loadFiles();
      }

      $scope.loadFiles = function(){
        D.query('file', 'type=reference&field=tmupload&entityId=' + $scope.referenceId).then(function(response){
          $scope.files = response;
          
        }).catch(console.error);
      }

      function setFieldName(){
        return 'tmupload'// + new Date().getTime();
      }

      $scope.removeFile = function(id){
        ngDialog.openConfirm({
          template: '/app/views/entities/confirm.html',
          className: 'ngdialog-theme-default',
          scope: $scope
        }).then(function(value){
          D.remove('file', id).then(function(response){
            $scope.loadFiles();
          }).catch(console.error)
        });
      }

      $scope.initialized = false;
      $scope.watchActivated = false;
      $scope.init = function(){

    	if ($rootScope.user && $rootScope.user.id) {

    	      let account = $rootScope.user;
            
            $scope.referenceId = account.group.type === 'SUPPLIER' ? $scope.client + '-' + account.group.id : account.group.id + '-' + $scope.supplier;

    	        $scope.loadFiles();

    	        D.load('reference', $scope.referenceId).then(function (result) {
    	          $scope.reference = result;
    	          
    	          $scope.tmuploadform = {
    	            title: '',
    	            status: '',
    	            type: 'reference',
    	            model: result,
    	            fields: [
    	              /*{
    	                                  available: true,
    	                                  type: 'language',
    	                                  name: 'source',
    	                                  labelColumn: 4,
    	                                  inputColumn: 8,
    	                                  column: 6,
    	                                  placeholder: 'labels.SELECTLANGUAGE',
    	                                  onchange: selectedLang
    	                                }, {
    	                                  available: true,
    	                                  type: 'language',
    	                                  name: 'target',
    	                                  labelColumn: 4,
    	                                  inputColumn: 8,
    	                                  column: 6,
    	                                  placeholder: 'labels.SELECTLANGUAGE',
    	                                  onchange: selectedLang
    	                                }, {
    	                                  available: true,
    	                                  type: 'text',
    	                                  name: 'context',
    	                                  labelColumn: 4,
    	                                  inputColumn: 8,
    	                                  column: 6
    	                                },{
    	                                  available: false,
    	                                  type: 'separator'
    	                                }, */
    	              {
    	                available: true,
    	                type: 'file',
    	                label: 'fields.UPLOAD',
    	                name: setFieldName(),
    	                limit: -1,
    	                canUpload: true,
    	                onupload: $scope.uploadedFiles,
                      allow: 'zip|tmx',
                      hideFileList: true,
    	                bucket: $rootScope.bucketName($scope.client),
                      filesSelectable: $rootScope.user.admin,
                      selectionActions: [
                          { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                      ] 
    	              }, {
    	                available: false,
    	                type: 'submit',
    	                cls: 'btn-block',
    	                labelColumn: 4,
    	                inputColumn: 4
    	              }
    	            ],
    	            submit: function () {

    	            }
    	          }
    	        }).catch(console.error)
    	    
    	  

    	} else {
    	  if (!$scope.watchActivated) {
    	    $scope.watchActivated = true;
          
    	    $rootScope.$watch('user.id', function () {
    	      if (!$scope.initialized) {
    	        $scope.init();
    	      }
    	    });

    	  }
    	}
    	}
    $scope.init()

      $scope.openForm = function(file){
        file.notes = file.info.tmNotes;
        $scope.fileForm = {
            title: 'labels.REPORTANDNOTES',
            status: '',
            type: 'file',
            model: file,
            fields: [{
                available: true,
                type: 'static',
                name: 'name'
            },{
                available: true,
                type: 'staticFormatted',
                name: 'notes'
            },{
                available: true,
                type: 'file',
                canUpload: false,
                canDelete: false,
                name: 'report',
                zipFilename: file.name + '.' + $filter('translate')('fields.REPORT').replace(' ','_'),
                bucket: $rootScope.bucketName($scope.client) 
            }]
        }
        ngDialog.open({
            template: '/app/views/entities/reference-fileform.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope
        })
    }






    }
  ]);